export default __webpack_public_path__ + "static/media/unrevealed-envolope.d4948847.png";